import {
  EmploymentType,
  MaximumBudget,
  PropertyType,
  SearchProfileRangeEnum,
} from "@justhome/common/api/core";
import format from "date-fns/format";

export const federalStateLabels: Record<
  NonNullable<MaximumBudget["federalState"]>,
  string
> = {
  SCHLESWIG_HOLSTEIN: "Schleswig-Holstein",
  HAMBURG: "Hamburg",
  NIEDERSACHSEN: "Niedersachsen",
  BREMEN: "Bremen",
  NORDRHEIN_WESTFALEN: "Nordrhein-Westfalen",
  HESSEN: "Hessen",
  RHEINLAND_PFALZ: "Rheinland-Pfalz",
  BADEN_WUERTTEMBERG: "Baden-Württemberg",
  BAYERN: "Bayern",
  SAARLAND: "Saarland",
  BERLIN: "Berlin",
  BRANDENBURG: "Brandenburg",
  MECKLENBURG_VORPOMMERN: "Mecklenburg-Vorpommern",
  SACHSEN: "Sachsen",
  SACHSEN_ANHALT: "Sachsen-Anhalt",
  THUERINGEN: "Thüringen",
};

export const rangeLabels: Record<SearchProfileRangeEnum, string> = {
  "1": "+ 1 km",
  "5": "+ 5 km",
  "10": "+ 10 km",
  "20": "+ 20 km",
  "50": "+ 50 km",
};

export const propertyTypeLabels: Partial<Record<PropertyType, string>> = {
  APARTMENT: "type_of_property_apartment",
  SINGLE_FAMILY_HOUSE: "type_of_property_house",
  TOWNHOUSE: "type_of_property_townhouse",
  TWO_FAMILY_HOUSE: "type_of_property_two_family_house",
  APARTMENT_BUILDING: "type_of_property_apartment_building",
  LAND_PLOT: "type_of_property_land_plot",
};

export const employmentTypeLabels: Omit<
  Record<EmploymentType, string>,
  "HOUSEWIFE" | "CIVIL_SERVANT" | "WORKER" | "FREELANCER" | "STUDENT"
> = {
  EMPLOYED: "Angestellt",
  SELF_EMPLOYED: "Selbstständig",
  RETIRED: "Rentner:in",
  UNEMPLOYED: "Arbeitslos/Studierend",
};

export const federalStateLabel = (
  value: NonNullable<MaximumBudget["federalState"]>,
) => {
  return federalStateLabels[value];
};

export const employmentTypeLabel = (value: EmploymentType) => {
  return employmentTypeLabels[value];
};

/**
 * Formats a date string like "2020-01-02" into "2.1.2020".
 */
export const formatYearDayMonth = (date: string): string => {
  return format(new Date(date), "d.M.yyyy");
};

export const formatYear = (date: string): string => {
  return new Date(date).getFullYear().toString();
};
